import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-24 bg-navy px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-57">
      {/* Background accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-emerald/5 blur-3xl rounded-full pointer-events-none" data-id="element-58"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-59">
        <FadeIn data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 tracking-tight leading-tight" data-id="element-61">
            La próxima entrevista puede abrirte una gran oportunidad. No llegues
            sin estrategia.
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-62">
            Prepárate para destacar, generar conversación y mostrar con claridad
            por qué eres la mejor opción.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-63">
            <button className="bg-emerald text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-emerald-hover transition-colors shadow-lg w-full sm:w-auto" data-id="element-64">
              Quiero mi guía ahora
            </button>
            <p className="text-gray-400 text-sm font-medium" data-id="element-65">
              Descarga inmediata. Léela hoy. Aplícala en tu próxima entrevista.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}